import React, { useContext } from 'react';
import Colors from '../../../internal-components/Colors';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '../../engine/SelectEngine';
import styled from 'styled-components/macro';
import { FormContext } from '../FormContext';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const StyledOutlinedInput = styled(OutlinedInput)`
  border-radius: 6px !important;
  height: 37px;
  max-height: 37px;
  padding: 0.8rem;
  width: 100%;
  && input {
    font-size: 14px;
    height: 1.1875em;
    margin: 0;
    padding: 0;
  }
`;

const DialCodeSelect = styled(Select)`
  && {
    background: ${Colors.BACKGROUND_GREY};
    border: 0;
    width: 6.1rem;
    max-width: initial;
    min-height: 35px;
    padding: 0 0.8em;
    margin: 0 0 0 -13px;
    font-size: 14px;
  }

  input {
    padding: 0.5em 0.8em;
  }

  &:hover {
    border-color: #000;
  }
`;

const PhoneFieldView = props => {
  const { variant } = useContext(FormContext);
  return (
    <StyledFormControl>
      <StyledOutlinedInput
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onChange={props.handleLocalNumberChange}
        value={props.localNumber}
        startAdornment={
          <InputAdornment position="start">
            <DialCodeSelect
              searchable
              asyncOptions={props.asyncCountryOptions}
              disabled={props.readOnly}
              placeholder={props.country}
              value={props.country}
              openMenuOptionParser={props.openMenuOptionParser}
              onChange={props.handleChangeCountry}
              variant={variant}
              forceNonMobileVersion
            />
          </InputAdornment>
        }
        inputProps={{
          readOnly: props.readOnly
        }}
      />
    </StyledFormControl>
  );
};

export default PhoneFieldView;
